import {
  getMonth,
  lastDayOfMonth,
  startOfWeek,
  lastDayOfWeek,
  startOfQuarter,
  lastDayOfQuarter,
  subDays,
} from 'date-fns';

import { dateFormat } from './index';

export const CURRENT_YEAR = new Date().getFullYear();

/**
 * Получить год (Текущий год минус кол-во лет)
 * @param {Number} num - кол-во лет, на сколько отнять от текущего года
 * @returns {Number} год
 */
export const getYear = (num: number = 0) => {
  return CURRENT_YEAR - num;
};

/**
 * Период за произвольное кол-во последних дней
 * @param {Number} days за сколько дней
 */
export const periodForLastDays = (days: number = 365) => {
  return {
    start: dateFormat(subDays(new Date(), days), 'yyyy-MM-dd'),
    end: dateFormat(new Date(), 'yyyy-MM-dd'),
  };
};

/**
 * Период за неделю
 */
export const periodForWeek = () => {
  return {
    start: dateFormat(
      startOfWeek(new Date(), { weekStartsOn: 1 }),
      'yyyy-MM-dd'
    ),
    end: dateFormat(
      lastDayOfWeek(new Date(), { weekStartsOn: 1 }),
      'yyyy-MM-dd'
    ),
  };
};
/**
 * Период за месяц
 * @param {Number} year - указать год, по дефолту текущий
 * @param {Number | Date} date - new Date()
 */
export const periodForMonth = (
  date: number | Date = new Date(),
  year: number = CURRENT_YEAR
) => {
  const month = getMonth(date) + 1;
  return {
    start: `${year}-${month < 10 ? `0${month}` : month}-01`,
    end: dateFormat(lastDayOfMonth(date), 'yyyy-MM-dd'),
  };
};
/**
 * Период за квартал
 */
export const periodForQuarter = () => {
  return {
    start: dateFormat(startOfQuarter(new Date()), 'yyyy-MM-dd'),
    end: dateFormat(lastDayOfQuarter(new Date()), 'yyyy-MM-dd'),
  };
};
/**
 * Период за год
 * @param {Number} num - указать сколько лет вычесть из текущего года, по дефолту текущий
 */
export const periodForYear = (num: number = 0) => {
  return {
    start: `${getYear(num)}-01-01`,
    end: `${getYear(num)}-12-31`,
  };
};
